import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"
import { navigate } from "gatsby"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import Tag from "../tag/tag"
import ResultImageGroup from "../resultsimage/resultsimagegroup"
import ResultsDisclaimer from "../resultsdisclaimer/resultsdisclaimer"

import { ProductText, TagsContainer } from "./resultscard.styled"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

const Name = styled(TextElementNova)``

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const ImageWrapper = styled.div`
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  overflow: hidden;
`

const ResultsInfoWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 40px;
  flex-direction: column;
  padding: 16px;
  border-width: 0 1px 1px 1px;
  border-color: ${theme.wild.color.nova.transparency.black[20]};
  border-style: solid;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  @media (min-width: 768px) {
    padding: 24px;
    gap: 32px;
  }

  @media (min-width: 1024px) {
    padding: 32px;
    gap: 48px;
  }
`

const ResultsCard = ({
  afterImage,
  beforeImage,
  imageDirection = "center",
  after,
  name,
  product,
  tags,
  action,
  badgePosition = "bottom-left",
  pdp,
  disclaimer,
  slideDisclaimer = null,
  slideDisclaimerAlt,
  showDisclaimer = true,
  showDisclaimerAlt = false,
}) => {
  const resultImageData = {
    badgePosition,
    imageDirection,
    before: {
      image: beforeImage,
      label: "Before",
      alt: `${name} before ${action.toLowerCase()} ${product}.`,
      role: "presentation",
    },
    after: {
      image: afterImage,
      label: `${after} months growing`,
      alt: `${name} ${after} months into ${action.toLowerCase()} ${product}. Results are from a clinical study and may vary`,
      role: "presentation",
    },
  }

  const useLink =
    pdp &&
    (typeof window !== "undefined"
      ? !window.location.pathname.includes(pdp) &&
        !window.location.pathname.includes("womens-core-vegan")
      : true)

  const onClick = () => {
    if (useLink) {
      segmentEvent("Marketing CTA Clicked", {
        destination: pdp,
        text: product,
        type: "link",
      })
      navigate(pdp)
    } else {
      //we dont want user to leave page when results lead to same page eg /womens-vegan/
    }
  }

  const disclaimerToShow = showDisclaimer
    ? slideDisclaimer ?? disclaimer
    : showDisclaimerAlt
    ? slideDisclaimerAlt ?? disclaimer
    : null

  return (
    <CardWrapper>
      <ImageWrapper>
        <ResultImageGroup {...resultImageData} />
      </ImageWrapper>
      <ResultsInfoWrapper>
        {name ? (
          <Name element="h3" text={name} className="Subtitle-10-Dia-Normal" />
        ) : null}
        {tags?.length > 0 ? (
          <TagsContainer mb="auto">
            {tags?.map((tag) => (
              <Tag key={tag} data={{ line: tag }} />
            ))}
          </TagsContainer>
        ) : null}
        {/* see NT2-23277 DUO PDP Redesign | Tablet Before & After Spacing issues */}
        {product ? (
          <Box pt={[0, 0, 102, 0]}>
            <ProductText
              onClick={onClick}
              className={`CTA-20-Dia-Normal text-nova-transparency-black-70 ${
                useLink ? "cursor-pointer" : ""
              }`}
              text={`${action} <a>${product}</a>`}
            />
            {disclaimerToShow ? (
              <ResultsDisclaimer data={disclaimerToShow} mt={8} />
            ) : null}
          </Box>
        ) : null}
      </ResultsInfoWrapper>
    </CardWrapper>
  )
}

export default ResultsCard
